// extracted by mini-css-extract-plugin
export var avatarContainer = "_57-0";
export var avatarTypingWave = "_57-i";
export var gray = "_57-f";
export var green = "_57-c";
export var icon = "_57-9";
export var image = "_57-1";
export var lg = "_57-6";
export var md = "_57-5";
export var presenceDot = "_57-b";
export var red = "_57-d";
export var sm = "_57-4";
export var status = "_57-a";
export var typingDot = "_57-h";
export var typingPill = "_57-g";
export var xl = "_57-7";
export var xs = "_57-3";
export var xxl = "_57-8";
export var xxs = "_57-2";
export var yellow = "_57-e";